import { useCallback, useMemo, useState } from 'react'

import Document from './document'
import Information from './information'
import Market from './market'
import SellingDetails from './selling-details'
import Transaction from './transaction'

export enum TabsContentPTOV3 {
  DETAILS = 0,
  DOCUMENT = 1,
  SELLING_DETAILS = 2,
  TRANSACTION = 3,
  MARKET = 4,
}

/**
 * PTO v3 tabs: Details, Document, Selling Details, Transaction (GET /admin/pto/transaction
 * by contract address) and Market (market chart of the PTO).
 */
const Content = () => {
  const [tab, setTab] = useState(TabsContentPTOV3.DETAILS)

  const CONTENT_TABS = useMemo(() => {
    return [
      { value: TabsContentPTOV3.DETAILS, label: 'Details' },
      { value: TabsContentPTOV3.DOCUMENT, label: 'Document' },
      { value: TabsContentPTOV3.SELLING_DETAILS, label: 'Selling Details' },
      { value: TabsContentPTOV3.TRANSACTION, label: 'Transaction' },
      { value: TabsContentPTOV3.MARKET, label: 'Market' },
    ]
  }, [])

  const renderContent = useCallback(() => {
    switch (tab) {
      case TabsContentPTOV3.DETAILS:
        return <Information />
      case TabsContentPTOV3.DOCUMENT:
        return <Document />
      case TabsContentPTOV3.SELLING_DETAILS:
        return <SellingDetails />
      case TabsContentPTOV3.TRANSACTION:
        return <Transaction />
      case TabsContentPTOV3.MARKET:
        return <Market />
      default:
        return <div>Details</div>
    }
  }, [tab])

  return (
    <>
      <div className="tab-group">
        {CONTENT_TABS.map((contentTab, index) => {
          return (
            <p
              key={index}
              className={tab === contentTab.value ? 'selected' : ''}
              onClick={() => {
                setTab(contentTab.value)
              }}
            >
              {contentTab.label}
            </p>
          )
        })}
      </div>
      {renderContent()}
    </>
  )
}

export default Content
